import { render, staticRenderFns } from "./KPIPageDetail.vue?vue&type=template&id=ebd1695c&scoped=true"
import script from "./KPIPageDetail.vue?vue&type=script&lang=js"
export * from "./KPIPageDetail.vue?vue&type=script&lang=js"
import style0 from "./KPIPageDetail.vue?vue&type=style&index=0&id=ebd1695c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd1695c",
  null
  
)

export default component.exports